import { map, flatten, get } from "lodash"
//User設定系
import { tableColumns } from "./table_columns"

export const SAVE_AUTH_TEXT_FLAG = {
  Disabled: {
    id: 0,
    name: "無効",
  },
  Enabled: {
    id: 1,
    name: "保存",
  },
}

//定義値
export const COMMODITY = {
  EQUITY: { id: 1, name: "現物" },
  TRUST: { id: 2, name: "信用" },
  FUTURE: { id: 3, name: "先物" },
  OPTION: { id: 4, name: "オプション" },
  MUTUALFUND: { id: 5, name: "投資信託" },
  CFD: { id: 6, name: "株価指数証拠金取引(CFD)" },
}

export const SECURITY_TYPE = {
  //ICで使用したもののみを転記　検討して再編成すべき
  Index: { id: 0, name: "指数", Commodity: 1 },
  Equity: { id: 1, name: "株式", Commodity: 1 },
  OpenInvestmentTrust: {
    id: 20,
    name: "投資信託(分配金受取)",
    course: "分配金受取コース",
  },
  AccumlaiveInvestmentTrust: {
    id: 21,
    name: "投資信託(分配金再投資)",
    course: "分配金再投資コース",
  },
  US_Equity: { id: 100, name: "米国株" },
  NK225_Future: {
    id: 101,
    name: "日経225先物",
    Commodity: 3,
    seq: 1,
    marketName: "N225先物",
  },
  NK225_Option: {
    id: 103,
    name: "日経225オプション",
    Commodity: 4,
  },
  TOPIX_Future: {
    id: 107,
    name: "TOPIX先物",
    Commodity: 3,
    seq: 3,
    marketName: "TPX先物",
  },
  TOPIX_Option: {
    id: 109,
    name: "TOPIX オプション",
  },
  NY_DOW: { id: "144", name: "NYダウ" },
  JPX400_Future: {
    id: 121,
    name: "JPX日経インデックス400先物",
    Commodity: 3,
    seq: 5,
    marketName: "JPX400先物",
  },
  TSE_MOTHERS_Future: {
    id: 154,
    name: "東証マザーズ指数先物",
    Commodity: 3,
    seq: 4,
    marketName: "マザーズ先物",
  },
  REIT: {
    id: 155,
    name: "REIT指数",
  },
  CORE30_Future: {
    id: 171,
    name: "CORE30先物",
  },
  JGB: {
    id: 601,
    name: "長期国債先物",
  },
  NK225_Future_Mini: {
    id: 901,
    name: "ミニ日経225先物",
    Commodity: 3,
    seq: 2,
    marketName: "N225ミニ",
  },
  TOPIX_Future_Mini: { id: 907, name: "TOPIXミニ 先物" },
  SWFX: { id: 12000, name: "SWFX", Commodity: 1 },
  THGBY10: { id: 13001, name: "タイ１０年国債" },
  CNGBY10: { id: 13002, name: "中国１０年国債" },
  JPGBY10: { id: 13003, name: "日本１０年長期国債" },
  HKGBY10: { id: 13004, name: "香港１０年国債" },
  USGBY10: { id: 13005, name: "米国１０年国債" },
  ZAGBY10: { id: 13006, name: "南アフリカ１０年国債" },
  KRGBY10: { id: 13007, name: "韓国１０年国債" },
  VNGBY10: { id: 13008, name: "ベトナム１０年国債" },
  RUGBY10: { id: 13009, name: "ロシア１０年国債" },
  PHGBY10: { id: 13010, name: "フィリピン１０年国債" },
  IDGBY10: { id: 13011, name: "インドネシア１０年国債" },
  TWGBY10: { id: 13012, name: "台湾１０年国債" },
  GBGBY10: { id: 13013, name: "英国１０年国債" },
  MYGBY10: { id: 13014, name: "マレーシア１０年国債" },
  EUGBY10: { id: 13015, name: "ユーロゾーン１０年国債" },
  DEGBY10: { id: 13016, name: "ドイツ１０年国債" },
  FRGBY10: { id: 13017, name: "フランス１０年国債" },
  SGGBY10: { id: 13018, name: "シンガポール１０年国債" },
  NZGBY10: { id: 13019, name: "ニュージーランド１０年国債" },
  AUGBY10: { id: 13020, name: "オーストラリア１０年国債" },
  BRGBY10: { id: 13021, name: "ブラジル１０年国債" },
  PIR: { id: 13101, name: "政策金利" }, //Policy Interest Rate
  XAU: { id: 14001, name: "金 現物" },
  XAG: { id: 14002, name: "銀 現物" },
  GCc1: { id: 14101, name: "金 NY先物" },
  SIc1: { id: 14102, name: "銀 NY先物" },
  NK225Fc1: { id: 14106, name: "日経平均先物CME" },
  PLc1: { id: 14111, name: "プラチナ NY先物" },
  PAc1: { id: 14112, name: "パラジウム NY先物" },
  CLc1: { id: 14113, name: "WTI原油 先物" },
  XAUFIX: { id: 14201, name: "ロンドン金フィキシング" },
}

//仕様か所に配慮しながら拡張可 Exchangeとか必要なら
export const EQUITY_SECURITY_LIST = [
  { icon: "jp", SecurityType: 1, country: "日本" },
  { icon: "us", SecurityType: 100, country: "米国" },
  { icon: "hong-kong", SecurityType: 2011, country: "香港" },
  { icon: "china", SecurityType: 2021, country: "中国" },
  { icon: "taiwan", SecurityType: 2031, country: "台湾" },
  { icon: "korea", SecurityType: 2041, country: "韓国" },
  { icon: "singapore", SecurityType: 2051, country: "シンガポール" },
  { icon: "thailand", SecurityType: 2061, country: "タイ" },
  { icon: "malaysia", SecurityType: 2071, country: "マレーシア" },
  { icon: "indonesia", SecurityType: 2081, country: "インドネシア" },
  { icon: "philippines", SecurityType: 2091, country: "フィリピン" },
  { icon: "vietnam", SecurityType: 2101, country: "ベトナム" },
  { icon: "israel", SecurityType: 2111, country: "イスラエル" },
]

export const FOREIGN_STOCK = [
  EQUITY_SECURITY_LIST[1].SecurityType,
  EQUITY_SECURITY_LIST[2].SecurityType,
  EQUITY_SECURITY_LIST[3].SecurityType,
  EQUITY_SECURITY_LIST[4].SecurityType,
  EQUITY_SECURITY_LIST[5].SecurityType,
  EQUITY_SECURITY_LIST[6].SecurityType,
  EQUITY_SECURITY_LIST[7].SecurityType,
  EQUITY_SECURITY_LIST[8].SecurityType,
  EQUITY_SECURITY_LIST[9].SecurityType,
  EQUITY_SECURITY_LIST[10].SecurityType,
  EQUITY_SECURITY_LIST[11].SecurityType,
  EQUITY_SECURITY_LIST[12].SecurityType,
]

export const EXCHANGE = {
  NONE: { id: 0, name: "東証" },
  TSE: { id: 1, name: "東証" },
  OSE: { id: 2, name: "大証" },
  NSE: { id: 3, name: "名証" },
  FSE: { id: 5, name: "福証" },
  SSE: { id: 6, name: "札証" },
  OSE_DERIV_DAY: { id: 23, name: "大証派生日中" },
  OSE_DERIV_EVENING: { id: 24, name: "大証派生夕場" },
  NYSE: { id: 100 },
  US_EQUITY: { id: 300 },
  FX: { id: 400, name: "為替" },
  SZSE: { id: 2020, name: "深セン" },
  TWII: { id: 2030, name: "台湾" },
  KSSE: { id: 2040, name: "韓国" },
  STI: { id: 2050, name: "シンガポール" },
  SETI: { id: 2060, name: "タイ" },
  KLSE: { id: 2070, name: "マレーシア" },
  JKSE: { id: 2080, name: "インドネシア" },
  PSI: { id: 2090, name: "フィリピン" },
  VNI: { id: 2100, name: "ベトナム" },
  ILSE: { id: 2110, name: "イスラエル" },
  HKSE: { id: 3010, name: "香港" },
  SSEC: { id: 3020, name: "上海" },
  GB: { id: 13000, name: "国債" },
  PIR: { id: 13101, name: "政策金利" }, //Policy Interest Rate
  XAU_XAG: { id: 14000 }, //金現物,銀現物
}

export const EXCHANGE_LIST: Array<{ id: number; name?: string }> = Object.keys(
  EXCHANGE
).map(key => get(EXCHANGE, key))

export const CASH_MARGIN = {
  Stock: {
    id: 1,
    name: "現物",
  },
  New: {
    id: 2,
    name: "新規",
  },
  Return: {
    id: 3,
    name: "返済",
  },
  StockRecept: {
    id: 100,
    name: "品受",
  },
  StockDelivery: {
    id: 101,
    name: "品渡",
  },
}

export const PRICE_STATUS = {
  "0011": "現値",
  "0012": "板寄",
  "0013": "中断",
  "0014": "売停",
  "0015": "解除",
  "0016": "シ停",
  "0017": "解除",
  "0018": "CB",
  "0019": "CB解",
  "0022": "参考",
  "0023": "終値",
  "0033": "不連",
  "0046": "留解",
  "0050": "障解",
  "0378": "留保",
  "0427": "CB発",
  "0428": "CB解",
  "0430": "現値",
}

export const PRICE_COMPARE = {
  EQUAL: { id: "0000" },
  UP: { id: "0057" },
  DOWN: { id: "0058" },
}

export const PUT_OR_CALL = {
  PUT: {
    id: 1,
    name: "プット",
  },
  CALL: {
    id: 2,
    name: "コール",
  },
}

export const MARKET_VARIABLES = {
  //マーケット情報内のすべてのページ初期値を定義。変更はないため、変えない
  DEFAULT_PAGE: 1,
  INDUSTRY: [
    {
      value: "",
      label: "全業種",
    },
    {
      value: "0050",
      label: "水産・農林業",
    },
    {
      value: "1050",
      label: "鉱業",
    },
    {
      value: "2050",
      label: "建設業",
    },
    {
      value: "3050",
      label: "食料品",
    },
    {
      value: "3100",
      label: "繊維製品",
    },
    {
      value: "3150",
      label: "パルプ・紙",
    },
    {
      value: "3200",
      label: "化学",
    },
    {
      value: "3250",
      label: "医薬品",
    },
    {
      value: "3300",
      label: "石油・石炭製品",
    },
    {
      value: "3350",
      label: "ゴム製品",
    },
    {
      value: "3400",
      label: "ガラス・土石製品",
    },
    {
      value: "3450",
      label: "鉄鋼",
    },
    {
      value: "3500",
      label: "非鉄金属",
    },
    {
      value: "3550",
      label: "金属製品",
    },
    {
      value: "3600",
      label: "機械",
    },
    {
      value: "3650",
      label: "電気機器",
    },
    {
      value: "3700",
      label: "輸送用機器",
    },
    {
      value: "3750",
      label: "精密機器",
    },
    {
      value: "3800",
      label: "その他製品",
    },
    {
      value: "4050",
      label: "電気・ガス業",
    },
    {
      value: "5050",
      label: "陸運業",
    },
    {
      value: "5100",
      label: "海運業",
    },
    {
      value: "5150",
      label: "空運業",
    },
    {
      value: "5200",
      label: "倉庫・輸送関連業",
    },
    {
      value: "5250",
      label: "情報・通信業",
    },
    {
      value: "6050",
      label: "卸売業",
    },
    {
      value: "6100",
      label: "小売業",
    },
    {
      value: "7050",
      label: "銀行業",
    },
    {
      value: "7100",
      label: "証券、商品先物取引業",
    },
    {
      value: "7150",
      label: "保険業",
    },
    {
      value: "7200",
      label: "その他金融業",
    },
    {
      value: "8050",
      label: "不動産業",
    },
    {
      value: "9050",
      label: "サービス業",
    },
    {
      value: "0000",
      label: "その他",
    },
  ],
  MARKET: {
    INDEX: {
      TOP: ["101", "144", "151", "103", "105", "154", "190"],
      TOUSHO: [
        "101",
        "151",
        "152",
        "156",
        "157",
        "158",
        "103",
        "105",
        "154",
        "155",
      ],
      JASDAQ: ["190", "191", "194", "195", "154"],
    },
    STATISTICS: {
      TOUSHO: ["0111", "0112"],
      JASDAQ: ["0124", "0126", "0114"],
    },
    SIDE: {
      SUBTRACT: {
        id: 0,
        name: "差引",
        className: "",
      },
      SELL: {
        id: 1,
        name: "売",
        className: "sell",
      },
      BUY: {
        id: 2,
        name: "買",
        className: "buy",
      },
    },
  },
  RANKING: {
    DISPLAY_SUMMARY_NUM: 10,
    DISPLAY_NUM: 50,
    DAY_BEFORE: "0",
    STOCK_TABLE: {
      Price: ["値上り率", "値下り率", "売買高", "売買代金"],
      HighRate: ["売買高急増"],
      StockRate: ["低PER", "低PBR"],
      Ticks: ["TICK回数"],
    },
    TYPES: {
      SUMMARY: [
        {
          label: "値上り率",
          value: "1",
        },
        {
          label: "値下り率",
          value: "2",
        },
        {
          label: "売買高",
          value: "3",
        },
      ],
      STOCK: [
        { value: "1", label: "値上り率" },
        { value: "2", label: "値下り率" },
        { value: "3", label: "売買高" },
        { value: "4", label: "売買代金" },
        { value: "6", label: "売買高急増" },
        { value: "9", label: "低PER" },
        { value: "10", label: "低PBR" },
        { value: "5", label: "TICK回数" },
      ],
      GYOSHU: {
        label: "業種",
        value: "801",
      },
      TRUST: [
        {
          label: "信用売残増",
          value: "1000",
        },
        {
          label: "信用売残減",
          value: "1001",
        },
        {
          label: "信用買残増",
          value: "1010",
        },
        {
          label: "信用買残減",
          value: "1020",
        },
        {
          label: "信用高倍率",
          value: "1030",
        },
        {
          label: "信用低倍率",
          value: "1040",
        },
      ],
    },
    MARKET: {
      STOCK: [
        {
          value: "01",
          label: "全取引所",
        },
        {
          value: "02",
          label: "東証全体",
        },
        {
          value: "03",
          label: "東証1部",
        },
        {
          value: "04",
          label: "東証2部",
        },
        {
          value: "09",
          label: "東証JQ",
        },
        {
          value: "05",
          label: "東証マザーズ",
        },
        {
          value: "11",
          label: "名証",
        },
        {
          value: "12",
          label: "福証",
        },
        {
          value: "13",
          label: "札証",
        },
      ],
      TRUST: [
        {
          value: "1",
          label: "全取引所",
        },
        {
          value: "2",
          label: "東証全体",
        },
        {
          value: "7",
          label: "東証1部",
        },
        {
          value: "8",
          label: "東証2部",
        },
        {
          value: "4",
          label: "東証JQ",
        },
        {
          value: "9",
          label: "東証マザーズ",
        },
        {
          value: "6",
          label: "名証",
        },
      ],
    },
  },
  SYMBOL_DETAIL_CONTENTS: {
    PRICE: { title: "価格", id: 1 },
    INDEX: { title: "指標", id: 2 },
    CHART: { title: "チャート", id: 3 },
    ANALYTICS: { title: "時価分析", id: 4 },
    BENEFIT: { title: "株主優待", id: 5 },
    NEWS: { title: "ニュース", id: 6 },
    SETTLEMENT: { title: "決算", id: 7 },
    VIDUAL: { title: "ビジュアル決算", id: 8 },
    CREDIT: { title: "信用証金", id: 9 },
    CURRENT: { title: "現在値一覧", id: 10 },
    DAILY: { title: "日足", id: 11 },
  },
}

export const SCREENING_FILTER = {
  display_pattern: [
    {
      type: "PER",
      name: "時価総額・PER(連結優先)・PBR(連結優先)・配当利回り",
    },
    {
      type: "RSI",
      name: "RSI・ｻｲｺﾛｼﾞｶﾙ・ｽﾄｷｬｽ(%D)・ｽﾄｷｬｽ(ｽﾛｰ%D)・ﾎﾞﾘｭｰﾑﾚｼｵ",
    },
    {
      type: "MAER",
      name: "5日／25日／13週／26週移動平均乖離率・信用倍率",
    },
  ],
  columns: [
    { Name: "銘柄コード", Code: "Symbol" },
    { Name: "PER（連結優先）", Code: "PER" },
    { Name: "PBR（連結優先）", Code: "PBR" },
    { Name: "配当利回り", Code: "DividendYield" },
    { Name: "前日終値", Code: "LastClose" },
    { Name: "騰落率", Code: "ChangedRatio" },
    { Name: "時価総額", Code: "TotalMarketValue" },
    { Name: "RSI", Code: "RSI" },
    { Name: "ｻｲｺﾛｼﾞｶﾙﾗｲﾝ", Code: "Psychological" },
    { Name: "ｽﾄｷｬｽﾃｨｸｽ9(%D)", Code: "STC" },
    { Name: "ｽﾄｷｬｽﾃｨｸｽ9(ｽﾛｰ%D)", Code: "SlowSTC" },
    { Name: "ﾎﾞﾘｭｰﾑﾚｼｵ", Code: "VolumeRatio" },
    { Name: "信用倍率", Code: "MarginRatio" },
    { Name: "5日移動平均乖離率", Code: "MAER5" },
    { Name: "25日移動平均乖離率", Code: "MAER25" },
    { Name: "13週移動平均乖離率", Code: "MAER13W" },
    { Name: "26週移動平均乖離率", Code: "MAER26W" },
  ],
  exchangeButtons: ["全市場を選択", "東証を選択", "選択クリア"],
}

export const MARKET = [
  { id: "", name: "" },
  { id: "T", name: "東証" },
  { id: "JQ", name: "JQ" },
  { id: "NG", name: "名証" },
  { id: "FU", name: "福証" },
  { id: "SP", name: "札証" },
  { id: "HK", name: "香港" },
  { id: "SS", name: "上海" },
  { id: "SZ", name: "深セン" },
  { id: "NE", name: "NYSE" },
  { id: "NQ", name: "NASDAQ" },
  { id: "KS", name: "韓国" },
  { id: "KQ", name: "KOSDAQ" },
  { id: "TW", name: "台湾" },
  { id: "SI", name: "シンガポール" },
  { id: "JK", name: "インドネシア" },
  { id: "KL", name: "マレーシア" },
  { id: "HM", name: "ホーチミン" },
  { id: "HN", name: "ハノイ" },
  { id: "BK", name: "タイ" },
  { id: "PS", name: "フィリピン" },
]

export const INDEX_SYMBOL_LIST_KOKUNAI = [
  { Symbol: "101", SymbolName: "日経平均", SecurityType: 0, Exchange: 1 },
  { Symbol: "151", SymbolName: "TOPIX", SecurityType: 0, Exchange: 1 },
  { Symbol: "105", SymbolName: "JPX日経400", SecurityType: 0, Exchange: 1 },
  {
    Symbol: "154",
    SymbolName: "東証マザーズ指数",
    SecurityType: 0,
    Exchange: 1,
  },
  { Symbol: "103", SymbolName: "日経300", SecurityType: 0, Exchange: 1 },
  { Symbol: "152", SymbolName: "2部指数", SecurityType: 0, Exchange: 1 },
  { Symbol: "156", SymbolName: "指数大型", SecurityType: 0, Exchange: 1 },
  { Symbol: "157", SymbolName: "指数中型", SecurityType: 0, Exchange: 1 },
  { Symbol: "158", SymbolName: "指数小型", SecurityType: 0, Exchange: 1 },
  { Symbol: "155", SymbolName: "REIT指数", SecurityType: 0, Exchange: 1 },
  { Symbol: "191", SymbolName: "日経JQ平均", SecurityType: 0, Exchange: 1 },
  { Symbol: "190", SymbolName: "JQ IDX", SecurityType: 0, Exchange: 1 },
  { Symbol: "194", SymbolName: "JQ IDX S", SecurityType: 0, Exchange: 1 },
  { Symbol: "195", SymbolName: "JQ IDX G", SecurityType: 0, Exchange: 1 },
]

export const INDEX_SYMBOL_LIST = [
  // トップページ指数銘柄
  { Symbol: "101", SymbolName: "日経平均株価" },
  { Symbol: "101", SymbolName: "日経225先物" },
  { Symbol: "101", SymbolName: "JASDAQ指数" },
  { Symbol: "101", SymbolName: "東証1部出来高" },
  { Symbol: "151", SymbolName: "TOPIX" },
  { Symbol: "101", SymbolName: "米ドル/円" },
  { Symbol: "103", SymbolName: "日経株価指数300" },
  { Symbol: "105", SymbolName: "JPX 日経インデックス400" },
  { Symbol: "151", SymbolName: "東証株価指数" },
  { Symbol: "152", SymbolName: "第二部株価指数" },
  { Symbol: "154", SymbolName: "東証マザーズ指数" },
  { Symbol: "155", SymbolName: "東証REIT指数" },
  { Symbol: "156", SymbolName: "大型" },
  { Symbol: "157", SymbolName: "中型" },
  { Symbol: "158", SymbolName: "小型" },
  { Symbol: "190", SymbolName: "JASDAQ INDEX（総合）" },
  { Symbol: "191", SymbolName: "日経ジャスダック平均株価" },
  { Symbol: "194", SymbolName: "JASDAQ INDEX（スタンダード）" },
  { Symbol: "195", SymbolName: "JASDAQ INDEX（グロース）" },
  { Symbol: "321", SymbolName: "水産・農林業" },
  { Symbol: "322", SymbolName: "鉱業" },
  { Symbol: "323", SymbolName: "建設業" },
  { Symbol: "324", SymbolName: "食料品" },
  { Symbol: "325", SymbolName: "繊維製品" },
  { Symbol: "326", SymbolName: "パルプ・紙" },
  { Symbol: "327", SymbolName: "化学" },
  { Symbol: "328", SymbolName: "医薬品" },
  { Symbol: "329", SymbolName: "石油・石炭製品" },
  { Symbol: "330", SymbolName: "ゴム製品" },
  { Symbol: "331", SymbolName: "ガラス・土石製品" },
  { Symbol: "332", SymbolName: "鉄鋼" },
  { Symbol: "333", SymbolName: "非鉄金属" },
  { Symbol: "334", SymbolName: "金属製品" },
  { Symbol: "335", SymbolName: "機械" },
  { Symbol: "336", SymbolName: "電気機器" },
  { Symbol: "337", SymbolName: "輸送用機器" },
  { Symbol: "338", SymbolName: "精密機器" },
  { Symbol: "339", SymbolName: "その他製品" },
  { Symbol: "340", SymbolName: "電気・ガス業" },
  { Symbol: "341", SymbolName: "陸運業" },
  { Symbol: "342", SymbolName: "海運業" },
  { Symbol: "343", SymbolName: "空運業" },
  { Symbol: "344", SymbolName: "倉庫・輸送関連業" },
  { Symbol: "345", SymbolName: "情報・通信業" },
  { Symbol: "346", SymbolName: "卸売業" },
  { Symbol: "347", SymbolName: "小売業" },
  { Symbol: "348", SymbolName: "銀行業" },
  { Symbol: "349", SymbolName: "証券、商品先物取引業" },
  { Symbol: "350", SymbolName: "保険業" },
  { Symbol: "351", SymbolName: "その他金融業" },
  { Symbol: "352", SymbolName: "不動産業" },
  { Symbol: "353", SymbolName: "サービス業" },
]

export const NEWS_TOGGLE = [
  { id: 0, title: "全て", key: "ALL" },
  { id: 1, title: "QUICKニュース", key: "QK" },
  { id: 2, title: "中国関連ニュース", key: "DZH" },
  { id: 3, title: "市況", key: "MDD_MARKET_REPORTS" },
  { id: 4, title: "材料", key: "MDD_IMPACT_NEWS" },
  { id: 5, title: "決算", key: "MDD_FINANCIAL_RESULTS" },
  { id: 6, title: "テク", key: "MDD_TECHNICAL_ANALYSIS" },
  { id: 7, title: "特集", key: "MDD_SPECIAL_EVENT" },
  { id: 8, title: "経済", key: "MDD_ECONOMIC_CONDITIONS" },
  { id: 9, title: "注目", key: "MDD_REMARKABLE_NEWS" },
  { id: 10, title: "特報", key: "MDD_SPECIAL_NEWS" },
  { id: 11, title: "為替", key: "MDD_FOREX_NEWS" },
]

type DETAIL_SEARCH_CONDITIONS_TYPE = {
  MARKETS: Array<{
    country: string
    markets: Array<{
      id: number
      name: string
    }>
    icon: string
    securityType: number
  }>
  TP_SECTORS: Array<{
    id: number
    name: string
  }>
  SP_SECTOR: Array<{
    category: string
    contents: Array<{
      id: number
      name: string
      SPSecCode: string
    }>
  }>
  RECOMMEND: Array<{
    id: number
    name: string
    value: Array<{
      type: number
      to: string | undefined
      from: string | undefined
    }>
  }>
  SCREENING: Array<{
    name: string
    items: Array<{
      name: string
      type: number
      min: number
      max: number
      unit: number
      minLabel: string
      maxLabel: string
    }>
  }>
  TABLE_OPTION: Array<{
    id: number
    name: string
    table: Array<object>
  }>
}
export const DETAIL_SEARCH_CONDITIONS: DETAIL_SEARCH_CONDITIONS_TYPE = {
  MARKETS: [
    {
      country: "日本",
      markets: [
        { id: 0, name: "東証1部" },
        { id: 1, name: "東証マザーズ" },
        { id: 2, name: "JASDAQ" },
        { id: 3, name: "東証2部" },
        { id: 4, name: "その他" },
      ],
      icon: "icon-solid icon-jp",
      securityType: 1,
    },
    {
      country: "米国",
      markets: [
        { id: 9, name: "米国ニューヨーク" },
        { id: 10, name: "米国NASDAQ" },
      ],
      icon: "icon-solid icon-us",
      securityType: 100,
    },
    {
      country: "香港",
      markets: [{ id: 5, name: "香港" }, { id: 6, name: "香港グロース" }],
      icon: "icon-solid icon-hong-kong",
      securityType: 2011,
    },
    {
      country: "中国",
      markets: [{ id: 7, name: "中国上海" }, { id: 8, name: "中国深セン" }],
      icon: "icon-solid icon-china",
      securityType: 2021,
    },
    {
      country: "ベトナム",
      markets: [{ id: 13, name: "ホーチミン " }, { id: 14, name: "ハノイ" }],
      icon: "icon-solid icon-vietnam",
      securityType: 2101,
    },
    {
      country: "韓国",
      markets: [{ id: 11, name: "韓国KOSPI" }, { id: 12, name: "韓国KOSDAQ" }],
      icon: "icon-solid icon-korea",
      securityType: 2041,
    },
    {
      country: "台湾",
      markets: [{ id: 16, name: "台湾" }],
      icon: "icon-solid icon-taiwan",
      securityType: 2031,
    },
    {
      country: "シンガポール",
      markets: [{ id: 17, name: "シンガポール" }],
      icon: "icon-solid icon-singapore",
      securityType: 2051,
    },
    {
      country: "タイ",
      markets: [{ id: 15, name: "タイ" }],
      icon: "icon-solid icon-thailand",
      securityType: 2061,
    },
    {
      country: "マレーシア",
      markets: [{ id: 19, name: "マレーシア" }],
      icon: "icon-solid icon-malaysia",
      securityType: 2071,
    },
    {
      country: "インドネシア",
      markets: [{ id: 18, name: "インドネシア" }],
      icon: "icon-solid icon-indonesia",
      securityType: 2081,
    },
    {
      country: "フィリピン",
      markets: [{ id: 20, name: "フィリピン" }],
      icon: "icon-solid icon-philippines",
      securityType: 2091,
    },
  ],
  TP_SECTORS: [
    { id: 0, name: "水産・農林業" },
    { id: 1, name: "食料品" },
    { id: 2, name: "鉱業" },
    { id: 3, name: "石油・石炭製品" },
    { id: 4, name: "建設業" },
    { id: 5, name: "金属製品" },
    { id: 6, name: "ガラス・土石製品" },
    { id: 7, name: "繊維製品" },
    { id: 8, name: "パルプ・紙" },
    { id: 9, name: "化学" },
    { id: 10, name: "医薬品" },
    { id: 11, name: "ゴム製品" },
    { id: 12, name: "輸送用機器" },
    { id: 13, name: "鉄鋼" },
    { id: 14, name: "非鉄金属" },
    { id: 15, name: "機械" },
    { id: 16, name: "電気機器" },
    { id: 17, name: "精密機器" },
    { id: 18, name: "その他製品" },
    { id: 19, name: "情報・通信業" },
    { id: 20, name: "サービス業" },
    { id: 21, name: "電気・ガス業" },
    { id: 22, name: "陸運業" },
    { id: 23, name: "海運業" },
    { id: 24, name: "空運業" },
    { id: 25, name: "倉庫・運輸関連業" },
    { id: 26, name: "卸売業" },
    { id: 27, name: "小売業" },
    { id: 28, name: "銀行業" },
    { id: 29, name: "証券・商品先物取引業" },
    { id: 30, name: "保険業" },
    { id: 31, name: "その他金融業" },
    { id: 32, name: "不動産業" },
  ],
  SP_SECTOR: [
    {
      category: "エネルギー",
      contents: [
        { id: 0, name: "エネルギー設備", SPSecCode: "1" },
        { id: 1, name: "天然資源", SPSecCode: "2" },
      ],
    },
    {
      category: "材料",
      contents: [
        { id: 2, name: "化学製品", SPSecCode: "3" },
        { id: 3, name: "建築材料", SPSecCode: "4" },
        { id: 4, name: "梱包材料", SPSecCode: "5" },
        { id: 5, name: "鉱物・採掘", SPSecCode: "6" },
        { id: 6, name: "紙・木材", SPSecCode: "7" },
      ],
    },
    {
      category: "資本財",
      contents: [
        { id: 7, name: "航空・防衛", SPSecCode: "8" },
        { id: 8, name: "建築製品", SPSecCode: "9" },
        { id: 9, name: "建設・エンジニアリング", SPSecCode: "10" },
        { id: 10, name: "電気設備", SPSecCode: "11" },
        { id: 11, name: "コングロマリット", SPSecCode: "12" },
        { id: 12, name: "機械", SPSecCode: "13" },
        { id: 13, name: "投資機関", SPSecCode: "14" },
      ],
    },
    {
      category: "広告・人材",
      contents: [
        { id: 14, name: "広告", SPSecCode: "15" },
        { id: 15, name: "人材", SPSecCode: "16" },
      ],
    },
    {
      category: "運輸",
      contents: [
        { id: 16, name: "空輸", SPSecCode: "17" },
        { id: 17, name: "航空会社", SPSecCode: "18" },
        { id: 18, name: "海運", SPSecCode: "19" },
        { id: 19, name: "鉄道・道路", SPSecCode: "20" },
        { id: 20, name: "運輸インフラ", SPSecCode: "21" },
      ],
    },
    {
      category: "自動車関連",
      contents: [
        { id: 22, name: "自動車", SPSecCode: "23" },
        { id: 21, name: "自動車部品", SPSecCode: "22" },
      ],
    },
    {
      category: "生活用品・衣料品",
      contents: [
        { id: 23, name: "生活用品", SPSecCode: "24" },
        { id: 24, name: "レジャー用品", SPSecCode: "25" },
        { id: 25, name: "衣料品", SPSecCode: "26" },
      ],
    },
    {
      category: "サービス業",
      contents: [
        { id: 26, name: "ホテル・レストラン・レジャー", SPSecCode: "27" },
        { id: 27, name: "その他サービス", SPSecCode: "28" },
      ],
    },
    {
      category: "小売業",
      contents: [
        { id: 29, name: "販売代理店", SPSecCode: "30" },
        { id: 30, name: "マーケティング", SPSecCode: "31" },
        { id: 31, name: "マルチ事業", SPSecCode: "32" },
        { id: 32, name: "専門小売", SPSecCode: "33" },
      ],
    },
    {
      category: "食糧品",
      contents: [{ id: 33, name: "食糧品", SPSecCode: "34" }],
    },
    {
      category: "食料・タバコ",
      contents: [
        { id: 34, name: "飲料", SPSecCode: "35" },
        { id: 35, name: "食品", SPSecCode: "36" },
        { id: 36, name: "タバコ", SPSecCode: "37" },
      ],
    },
    {
      category: "家庭用製品",
      contents: [
        { id: 37, name: "家庭用品", SPSecCode: "38" },
        { id: 38, name: "個人向け製品", SPSecCode: "39" },
      ],
    },
    {
      category: "健康設備・サービス",
      contents: [
        { id: 39, name: "健康設備", SPSecCode: "40" },
        { id: 40, name: "ヘルスケアサービス", SPSecCode: "41" },
        { id: 41, name: "健康技術", SPSecCode: "42" },
      ],
    },
    {
      category: "医療品",
      contents: [
        { id: 42, name: "バイオテクノロジー", SPSecCode: "43" },
        { id: 43, name: "医薬品", SPSecCode: "44" },
        { id: 44, name: "生命化学", SPSecCode: "45" },
      ],
    },
    {
      category: "銀行",
      contents: [
        { id: 45, name: "銀行", SPSecCode: "46" },
        { id: 46, name: "融資・貸付", SPSecCode: "47" },
      ],
    },
    {
      category: "金融業",
      contents: [
        { id: 47, name: "金融サービス", SPSecCode: "48" },
        { id: 48, name: "個人向け金融", SPSecCode: "49" },
        { id: 49, name: "投資", SPSecCode: "50" },
        { id: 66, name: "不動産担保証券(mREIT)", SPSecCode: "68" },
      ],
    },
    {
      category: "保険",
      contents: [{ id: 50, name: "保険", SPSecCode: "51" }],
    },
    {
      category: "ソフトウェア",
      contents: [
        { id: 53, name: "ITサービス", SPSecCode: "55" },
        { id: 54, name: "ソフトウェア", SPSecCode: "56" },
      ],
    },
    {
      category: "ハードウェア",
      contents: [
        { id: 55, name: "通信設備", SPSecCode: "57" },
        { id: 56, name: "ハードウェア", SPSecCode: "58" },
        { id: 57, name: "電子設備", SPSecCode: "59" },
      ],
    },
    {
      category: "半導体",
      contents: [{ id: 58, name: "半導体", SPSecCode: "60" }],
    },
    {
      category: "通信",
      contents: [
        { id: 59, name: "通信", SPSecCode: "61" },
        { id: 60, name: "無線通信", SPSecCode: "62" },
      ],
    },
    {
      category: "メディア",
      contents: [
        { id: 28, name: "メディア", SPSecCode: "29" },
        { id: 67, name: "エンタ―テイメント", SPSecCode: "69" },
        { id: 68, name: "インタラクティブメディア", SPSecCode: "70" },
      ],
    },
    {
      category: "インフラ設備",
      contents: [
        { id: 61, name: "電気", SPSecCode: "63" },
        { id: 62, name: "ガス", SPSecCode: "64" },
        { id: 63, name: "水道", SPSecCode: "65" },
        { id: 64, name: "複数設備事業", SPSecCode: "66" },
        { id: 65, name: "代替エネルギー", SPSecCode: "67" },
      ],
    },
    {
      category: "不動産",
      contents: [
        { id: 51, name: "不動産投資信託(REIT)", SPSecCode: "52" },
        { id: 52, name: "不動産管理・開発", SPSecCode: "53" },
      ],
    },
  ],
  RECOMMEND: [
    {
      id: 0,
      name: "高評価",
      value: [
        { type: 5, to: "2.5", from: undefined },
        { type: 6, to: "1", from: undefined },
      ],
    },
    {
      id: 1,
      name: "規模重視",
      value: [
        { type: 3, to: "2500", from: undefined },
        { type: 5, to: "1", from: undefined },
      ],
    },
    {
      id: 2,
      name: "割安",
      value: [
        { type: 4, to: undefined, from: "15" },
        { type: 5, to: undefined, from: "1" },
        { type: 6, to: "3", from: undefined },
      ],
    },
    {
      id: 3,
      name: "株価急上昇",
      value: [
        { type: 12, to: "5", from: undefined },
        { type: 13, to: "15", from: undefined },
      ],
    },
    { id: 4, name: "入力クリア", value: [] },
  ],
  SCREENING: [
    {
      name: "",
      items: [
        {
          name: "最低投資条件",
          type: 1,
          min: 0,
          max: 9999,
          unit: 10000,
          minLabel: "以上",
          maxLabel: "以下",
        },
      ],
    },
    {
      name: "価格",
      items: [
        {
          name: "前日終値",
          type: 2,
          min: 0,
          max: 99999999,
          unit: 1,
          minLabel: "以上",
          maxLabel: "以下",
        },
        {
          name: "騰落率",
          type: 3,
          min: -100,
          max: 100,
          unit: 1,
          minLabel: "％以上",
          maxLabel: "％以下",
        },
        {
          name: "時価総額",
          type: 18,
          min: 0,
          max: 99999999,
          unit: 100000000,
          minLabel: "億円以上",
          maxLabel: "億円以下",
        },
      ],
    },
    {
      name: "バリュー",
      items: [
        {
          name: "PER(連結優先)",
          type: 5,
          min: -10000,
          max: 10000,
          unit: 1,
          minLabel: "倍以上",
          maxLabel: "倍以下",
        },
        {
          name: "PBR(連結優先)",
          type: 6,
          min: -100,
          max: 100,
          unit: 1,
          minLabel: "倍以上",
          maxLabel: "倍以下",
        },
        {
          name: "配当利回り",
          type: 7,
          min: 0,
          max: 10,
          unit: 1,
          minLabel: "％以上",
          maxLabel: "％以下",
        },
      ],
    },
    {
      name: "テクニカル",
      items: [
        {
          name: "RSI(14日)",
          type: 8,
          min: 0,
          max: 100,
          unit: 1,
          minLabel: "％以上",
          maxLabel: "％以下",
        },
        {
          name: "サイコロジカルライン(12日)",
          type: 9,
          min: 0,
          max: 100,
          unit: 1,
          minLabel: "％以上",
          maxLabel: "％以下",
        },
        {
          name: "ストキャティクス9(%D)",
          type: 10,
          min: 0,
          max: 100,
          unit: 1,
          minLabel: "％以上",
          maxLabel: "％以下",
        },
        {
          name: "ストキャティクス9(スロー%D)",
          type: 11,
          min: 0,
          max: 100,
          unit: 1,
          minLabel: "％以上",
          maxLabel: "％以下",
        },
        {
          name: "ボリュームレシオ",
          type: 12,
          min: 0,
          max: 100,
          unit: 1,
          minLabel: "％以上",
          maxLabel: "％以下",
        },
        {
          name: "5日移動平均乖離率",
          type: 13,
          min: -100,
          max: 100,
          unit: 1,
          minLabel: "％以上",
          maxLabel: "％以下",
        },
        {
          name: "25日移動平均乖離率",
          type: 14,
          min: -100,
          max: 100,
          unit: 1,
          minLabel: "％以上",
          maxLabel: "％以下",
        },
        {
          name: "13週移動平均乖離率",
          type: 15,
          min: -100,
          max: 100,
          unit: 1,
          minLabel: "％以上",
          maxLabel: "％以下",
        },
        {
          name: "26週移動平均乖離率",
          type: 16,
          min: -100,
          max: 100,
          unit: 1,
          minLabel: "％以上",
          maxLabel: "％以下",
        },
        {
          name: "信用倍率",
          type: 17,
          min: 0,
          max: 100,
          unit: 1,
          minLabel: "倍以上",
          maxLabel: "倍以下",
        },
      ],
    },
  ],
  TABLE_OPTION: [
    {
      id: 0,
      name: "時価総額・PER・PBR・配当利回り",
      table: tableColumns.tool.screening.total,
    },
    {
      id: 1,
      name: "RSI、サイコロ、ストキャス(%D、スロー%D)、 ボリュームレシオ",
      table: tableColumns.tool.screening.rsi,
    },
    {
      id: 2,
      name: "移動平均乖離率(5日、 25日、 13週、 26週)、 信用倍率",
      table: tableColumns.tool.screening.average,
    },
  ],
}

type SP_SECTOR_LIST_TYPE = Array<{
  id: number
  name: string
  SPSecCode: string
}>
export const SP_SECTOR_LIST: SP_SECTOR_LIST_TYPE = flatten(
  map(DETAIL_SEARCH_CONDITIONS.SP_SECTOR, li => li.contents)
)

export type StockBenefitConditionListType = {
  id: number
  name: string
  icon?: string
  color?: string
  value?: string
  param?: { From?: number; To?: number }
}
export type StockBenefitConditionsType = {
  id: number
  name: string
  type:
    | "CHANGE_BENEFIT_MONTH"
    | "CHANGE_BENEFIT_CATEGORY"
    | "CHANGE_BENEFIT_PRICE"
  list: Array<StockBenefitConditionListType>
}

export const STOCK_BENEFIT_CONDITIONS: {
  [t: string]: StockBenefitConditionsType
} = {
  month: {
    id: 0,
    name: "優待確定月",
    type: "CHANGE_BENEFIT_MONTH",
    list: [
      { id: 0, name: "1月", value: "01" },
      { id: 1, name: "2月", value: "02" },
      { id: 2, name: "3月", value: "03" },
      { id: 3, name: "4月", value: "04" },
      { id: 4, name: "5月", value: "05" },
      { id: 5, name: "6月", value: "06" },
      { id: 6, name: "7月", value: "07" },
      { id: 7, name: "8月", value: "08" },
      { id: 8, name: "9月", value: "09" },
      { id: 9, name: "10月", value: "10" },
      { id: 10, name: "11月", value: "11" },
      { id: 11, name: "12月", value: "12" },
      { id: 12, name: "随時", value: "99" },
    ],
  },
  category: {
    id: 1,
    name: "優待区分",
    type: "CHANGE_BENEFIT_CATEGORY",
    list: [
      {
        id: 0,
        value: "1",
        name: "食料品",
        icon: "local_cafe",
        color: "color-food",
      },
      {
        id: 1,
        value: "2",
        name: "食事券",
        icon: "restaurant",
        color: "color-meal-ticket",
      },
      {
        id: 2,
        value: "3",
        name: "金券",
        icon: "local_atm",
        color: "color-cash-voucher",
      },
      {
        id: 3,
        value: "4",
        name: "カタログギフト",
        icon: "list_alt",
        color: "color-catalog",
      },
      {
        id: 4,
        value: "5",
        name: "交通・旅行",
        icon: "flight",
        color: "color-traffic",
      },
      {
        id: 5,
        value: "10",
        name: "スポーツ",
        icon: "directions_run",
        color: "color-sports",
      },
      {
        id: 6,
        value: "6",
        name: "暮らし",
        icon: "home_work",
        color: "color-living",
      },
      {
        id: 7,
        value: "7",
        name: "ポイントサービス",
        icon: "local_parking",
        color: "color-point",
      },
      {
        id: 8,
        value: "8",
        name: "美容・ファッション",
        icon: "local_mall",
        color: "fashion",
      },
      {
        id: 9,
        value: "9",
        name: "教養・娯楽",
        icon: "school",
        color: "color-school",
      },
      {
        id: 10,
        value: "11",
        name: "保育・介護・医療",
        icon: "local_hospital",
        color: "color-medical",
      },
      {
        id: 11,
        value: "12",
        name: "金融サービス",
        icon: "attach_money",
        color: "color-finance",
      },
      {
        id: 12,
        value: "13",
        name: "カレンダー",
        icon: "today",
        color: "color-calender",
      },
      {
        id: 13,
        value: "14",
        name: "長期保有特典",
        icon: "stars",
        color: "color-benefit",
      },
      {
        id: 14,
        value: "15",
        name: "社会貢献",
        icon: "group",
        color: "color-social",
      },
    ],
  },
  price: {
    id: 2,
    name: "投資金額別",
    type: "CHANGE_BENEFIT_PRICE",
    list: [
      { id: 0, name: "5万円未満", param: { From: 0, To: 49999 } },
      { id: 1, name: "5～10万円未満", param: { From: 50000, To: 99999 } },
      { id: 2, name: "10～30万円未満", param: { From: 100000, To: 299999 } },
      { id: 3, name: "30～50万円未満", param: { From: 300000, To: 499999 } },
      { id: 4, name: "50万円以上", param: { From: 500000 } },
    ],
  },
}

export const PERSONAL_SETTING_TYPE = {}

//登録銘柄・一括登録　拡張子リスト
export type REGISTER_EXTENSION_TYPE = {
  extension: string
  name: string
  SecurityType: number
  Exchange: number
}
export const REGISTER_EXTENSION: Array<REGISTER_EXTENSION_TYPE> = [
  { extension: "T", name: "東証", SecurityType: 1, Exchange: 1 },
  { extension: "NG", name: "名証", SecurityType: 1, Exchange: 3 },
  { extension: "FU", name: "福証", SecurityType: 1, Exchange: 5 },
  { extension: "SP", name: "札証", SecurityType: 1, Exchange: 6 },
  { extension: "NY", name: "ニューヨーク", SecurityType: 100, Exchange: 101 },
  { extension: "NQ", name: "NASDAQ", SecurityType: 100, Exchange: 102 },
  { extension: "HK", name: "香港", SecurityType: 2011, Exchange: 2011 },
  { extension: "SS", name: "上海", SecurityType: 2021, Exchange: 2021 },
  { extension: "SZ", name: "深セン", SecurityType: 2021, Exchange: 2022 },
  { extension: "KS", name: "韓国", SecurityType: 2041, Exchange: 2041 },
  { extension: "KQ", name: "KOSDAQ", SecurityType: 2041, Exchange: 2042 },
  { extension: "TW", name: "台湾", SecurityType: 2031, Exchange: 2031 },
  {
    extension: "HM",
    name: "ホーチミン",
    SecurityType: 2101,
    Exchange: 2101,
  },
  { extension: "HN", name: "ハノイ", SecurityType: 2101, Exchange: 2102 },
  {
    extension: "SI",
    name: "シンガポール",
    SecurityType: 2051,
    Exchange: 2051,
  },
  {
    extension: "JK",
    name: "インドネシア",
    SecurityType: 2081,
    Exchange: 2081,
  },
  {
    extension: "KL",
    name: "マレーシア",
    SecurityType: 2071,
    Exchange: 2071,
  },
  { extension: "BK", name: "タイ", SecurityType: 2061, Exchange: 2061 },
  {
    extension: "PS",
    name: "フィリピン",
    SecurityType: 2091,
    Exchange: 2091,
  },
]

//ヒートマップ
export const HEAT_MAP_LEVEL = [
  { cls: "heat-map-up-lv2", msg: "+3.01以上" },
  { cls: "heat-map-up-lv1", msg: "+0.01～3.00" },
  { cls: "heat-map-equal", msg: "0.00" },
  { cls: "heat-map-down-lv1", msg: "-0.01～-3.00" },
  { cls: "heat-map-down-lv2", msg: "-3.01以上" },
]
export const HEAT_MAP_LEVEL_UP = [
  { cls: "heat-map-up-lv5", msg: "+8.01以上" },
  { cls: "heat-map-up-lv4", msg: "+6.01～8.00" },
  { cls: "heat-map-up-lv3", msg: "+4.01～6.00" },
  { cls: "heat-map-up-lv2", msg: "+2.01～4.00" },
  { cls: "heat-map-up-lv1", msg: "+0.01～2.00" },
  { cls: "heat-map-equal", msg: "0.00" },
]
export const HEAT_MAP_LEVEL_DOWN = [
  { cls: "heat-map-down-lv1", msg: "-0.01～-2.00" },
  { cls: "heat-map-down-lv2", msg: "-2.01～-4.00" },
  { cls: "heat-map-down-lv3", msg: "-4.01～-6.00" },
  { cls: "heat-map-down-lv4", msg: "-6.01～-8.00" },
  { cls: "heat-map-down-lv5", msg: "-8.01以上" },
]

//タイムテーブル
export const TIME_TABLE_INFO = {
  hour: [8, 19],
  market: [
    {
      country: "東証",
      icon: "icon-jp",
      preOpen: false,
      close: [1500],
      open: [[900, 1130], [1230, 1500]],
    },
    {
      country: "名・福・札",
      icon: "icon-jp",
      preOpen: false,
      close: [1530],
      open: [[900, 1130], [1230, 1530]],
    },
    {
      country: "香港",
      icon: "icon-hong-kong",
      preOpen: [[1000, 1020], [1700, 1710]],
      close: [1010, 1655],
      open: [[1030, 1300], [1400, 1700]],
      attention:
        "香港-（プレオープニングセッション）10:00～10:20　 プレ対象注文締切10:10/（クロージングセッション）17:00 ～17:10",
    },
    {
      country: "上海/深セン",
      icon: "icon-china", // switch 1557
      preOpen: [[1015, 1025], [1555, 1600]],
      close: [1545],
      open: [[1030, 1230], [1400, 1555]],
      attention: "上海/深セン-（クロージングセッション）15:57～16:00",
    },
    {
      country: "台湾",
      icon: "icon-taiwan",
      preOpen: [[1425, 1430]],
      close: [1415],
      open: [[1000, 1425]],
      attention: "台湾-（クロージングセッション）14:25～14:30",
    },
    {
      country: "韓国",
      icon: "icon-korea",
      preOpen: [[1520, 1530]],
      close: [1525],
      open: [[900, 1520]],
      attention: "韓国-（クロージングセッション）15:20～15:30",
    },
    {
      country: "タイ",
      icon: "icon-thailand",
      preOpen: false,
      close: [1745],
      open: [[1200, 1430], [1630, 1830]],
    },
    {
      country: "シンガポール",
      icon: "icon-singapore",
      preOpen: false,
      close: [1745],
      open: [[1000, 1300], [1400, 1800]],
    },
    {
      country: "マレーシア",
      icon: "icon-malaysia",
      preOpen: [[1745, 1800]],
      close: [1745],
      open: [[1000, 1330], [1530, 1745]],
      attention: "マレーシア-（クロージングセッション）17:45～18:00",
    },
    {
      country: "インドネシア(月～木)",
      icon: "icon-indonesia",
      preOpen: false,
      close: [1745],
      open: [[1100, 1400], [1530, 1800]],
    },
    {
      country: "インドネシア(金)",
      icon: "icon-indonesia",
      preOpen: false,
      close: [1745],
      open: [[1100, 1330], [1600, 1800]],
    },
    {
      country: "フィリピン",
      icon: "icon-philippines",
      preOpen: [[1000, 1030], [1615, 1630]],
      close: [1615],
      open: [[1000, 1300], [1430, 1615]],
      attention: "フィリピン-（クロージングセッション）16:15～16:30",
    },
    {
      country: "ベトナム(ホーチミン)",
      icon: "icon-vietnam",
      preOpen: [[1100, 1115], [1630, 1645]],
      close: [1625],
      open: [[1115, 1330], [1500, 1630]],
      attention:
        "ホーチミン-（オープニングセッション）11：00～11：15/（クロージングセッション）16：30～16：45",
    },
    {
      country: "ベトナム(ハノイ)",
      icon: "icon-vietnam",
      preOpen: [[1630, 1645]],
      close: [1625],
      open: [[1100, 1330], [1500, 1630]],
      attention: "ハノイ- （クロージングセッション）16：30～16：45",
    },
  ],
}

//主にchartで使う
export const INDEX_SYMBOL_LIST_MAIN = [
  { Symbol: "101", SymbolName: "日経平均", SecurityType: 0, Exchange: 1 },
  { Symbol: "151", SymbolName: "TOPIX", SecurityType: 0, Exchange: 1 },
  {
    Symbol: "154",
    SymbolName: "東証マザーズ指数",
    SecurityType: 0,
    Exchange: 1,
  },
  { Symbol: "105", SymbolName: "JPX日経400", SecurityType: 0, Exchange: 1 },
  { Symbol: "144", SymbolName: "NYダウ", SecurityType: 0, Exchange: 1 },
]

// 足種別
export const LEG_TYPE = {
  "1m": "1分足",
  "5m": "5分足",
  "10m": "10分足",
  "15m": "15分足",
  "30m": "30分足",
  "1D": "日足",
  "1W": "週足",
  "1M": "月足",
}

export const LEG_TYPE_SELECT = [
  { id: 0, name: "1分足" },
  { id: 1, name: "5分足" },
  // { id: 2, name: "10分足" },
  // { id: 3, name: "15分足" },
  { id: 2, name: "30分足" },
  { id: 3, name: "日足" },
  { id: 4, name: "週足" },
  { id: 5, name: "月足" },
]

export const CHART_TYPE = [
  { id: "candle", name: "ローソク足" },
  { id: "line", name: "ラインチャート" },
  { id: "lineFill", name: "折れ線" },
  { id: "PandF", name: "ポイントフィギュア" },
]

export const CHART_RANGE = [
  { id: "0", name: "1ヵ月" },
  { id: "1", name: "2ヵ月" },
  { id: "2", name: "3ヵ月" },
  { id: "3", name: "6ヵ月" },
  { id: "4", name: "1年" },
]

//固定のdecimalsはここできめる
export const DECIMALS = {
  ChangedRatio: { decimal: 2, type: "floor", def: "-" },
  Delta: { decimal: 4, type: "round", def: "-" },
  Gamma: { decimal: 6, type: "round", def: "-" },
  Theta: { decimal: 4, type: "round", def: "-" },
  Vega: { decimal: 4, type: "round", def: "-" },
  Volatility: { decimal: 2, type: "round", def: "-" },
}

//文言系以下
export const ATTENTION_WORDS = {
  register: [
    {
      msg:
        "一括登録では現在表示されている登録銘柄を上書します。株数、購入単価、約定為替は初期化されます。",
      cls: "emphasis",
    },
    {
      msg:
        "証券コードに続いて市場の拡張子を入力してください。例:東証の8707銘柄を表示するには8708.Tと入力してください。",
      cls: "",
    },
    {
      msg: "銘柄ごとに改行してください。",
      cls: "",
    },
  ],
  heatmap: [
    { msg: "値動きの勢いは前日比 (%)によってカラー表示されます。", cls: "" },
  ],
}

export const REGULATION_MESSAGE = [
  { id: 1, message: "注意" },
  { id: 10, message: "禁止" },
]

export const TIME_TABLE_ATTENTION = [
  {
    msg: [
      "米国　取引時間　23:30～6:00 （夏時間の場合は22:30～5:00）",
      "当日注文締切時間　委託取引/国内店頭取引　15:30",
    ],
    cls: "",
  },
  {
    msg: [
      "欧州　取引時間　17:00～1:30 （夏時間の場合は16:00～0:30）",
      "当日注文締切時間　委託取引/国内店頭取引　14:30",
    ],
    cls: "",
  },
  {
    msg: [
      "イスラエル-取引時間　（夏時間）15:45～23:15/（冬時間）16:45～24:15",
      "当日注文締切時間　13:00",
      "注文受付日　月～木",
    ],
    cls: "",
  },
  { msg: "当日注文締切", cls: "label-time-status close-time" },
]

// 代行をそのまま持ってきた
export const AGENCY_FLAGS = {
  IsOperatorClosedAccountLogin: {
    key: "IsOperatorClosedAccountLogin",
    disp: "ログイン",
    disabled: true,
    values: [
      {
        display: "不可",
        value: 0,
      },
      {
        display: "可能にする",
        value: 1,
      },
    ],
  },
  IsOperatorIgnorePassword: {
    key: "IsOperatorIgnorePassword",
    disp: "代行発注機能",
    required: "D200000-001",

    values: [
      {
        display: "不可",
        value: 0,
      },
      {
        display: "可能",
        value: 1,
      },
    ],
  },
  IsOperatorEnableChange: {
    key: "IsOperatorEnableChange",
    disp: "その他変更機能",
    required: "D200000-002",
    values: [
      {
        display: "不可",
        value: 0,
      },
      {
        display: "可能",
        value: 1,
      },
    ],
  },
  IsOperatorForceOrder: {
    key: "IsOperatorForceOrder",
    disp: "強制注文設定",
    values: [
      {
        display: "通常注文とする",
        value: 0,
      },
      {
        display: "強制注文とする",
        value: 1,
      },
    ],
  },
  IsOperatorIgnoreChecks: {
    key: "IsOperatorIgnoreChecks",
    disp: "発注チェック機能解除",
    values: [
      {
        display: "チェック解除しない",
        value: 0,
      },
      {
        display: "チェック解除する",
        value: 1,
      },
    ],
  },
  ManualCommissionType: {
    key: "ManualCommissionType",
    disp: "適用手数料",
    values: [
      {
        display: "対面手数料",
        value: 2,
      },
      {
        display: "ネット手数料",
        value: 0,
      },
      {
        display: "無料",
        value: 1,
      },
    ],
  },
  IsOperatorIgnoreForceOrderCheck: {
    key: "IsOperatorIgnoreForceOrderCheck",
    disp: "",
    disabled: true,
  },
}

//event
export const KEY_CODE = {
  ENTER: 13,
  KEY_UP: 38,
  KEY_DOWN: 40,
}

//共通でのページング数量
export const PAGE_NUM = {
  PAGE_5: 5,
  PAGE_10: 10,
  PAGE_20: 20,
  PAGE_50: 50,
}

//FHが再起動したタイミングで降ってくる
export const INT_MINI = -2147483648

//テーブルソート用(ランキングでしか使わなければ移動する)
export const statusList = [
  { currentStatus: "neutral", nextStatus: "asc" },
  { currentStatus: "asc", nextStatus: "desc" },
  { currentStatus: "desc", nextStatus: "neutral" },
]

// 最初のPUSHサーバーへの接続を何回繰り返すか
export const FIRST_CONNECT_RETRY_MAX_COUNT = 5
export const FIRST_CONNECT_DELAY = 500

export const QUOTE_FLAG_LIST = [
  { code: "0000", disp: "" }, // 事象なし
  { code: "0101", disp: "・" }, // 一般気配
  { code: "0102", disp: "特" }, // 特別気配
  { code: "0103", disp: "注" }, // 注意気配
  { code: "0107", disp: "前" }, // 寄前気配
  { code: "0108", disp: "特" }, // 停止前特別気配
  { code: "0109", disp: "引" }, // 引け後気配
  { code: "0118", disp: "連" }, // 連続約定気配
  { code: "0119", disp: "連" }, // 停止前の連続約定気配
  { code: "-", disp: "W" }, // 一般気配（買上がり・売下がり中）
]

export const ROUTE_LIST = {
  TOP_SUMMARY: 0,
  TOP_INDEX: 1,
  TOP_EXCHANGE: 2,
  TOP_ECONOMICS: 3,
  TOP_BONDS: 4,
  TOP_INSTRUMENT: 5,
  TOP_BANK: 6,
  TOP_SETTLEMENT: 7,
  DOMESTIC_SUMMARY: 8,
  DOMESTIC_INDEX: 9,
  DOMESTIC_RANKING: 10,
  DOMESTIC_FUTURE: 11,
  DOMESTIC_OPTION: 12,
  DOMESTIC_AVERAGE: 13,
  DOMESTIC_INDUSTRY: 14,
  DOMESTIC_IPO: 15,
  DOMESTIC_STOCK: 16,
  DOMESTIC_CREDIT: 17,
  DOMESTIC_ETF: 18,
  DOMESTIC_REIT: 19,
  OVERSEAS_SUMMARY: 20,
  OVERSEAS_RANKING: 21,
  OVERSEAS_US: 22,
  OVERSEAS_HK: 23,
  OVERSEAS_CN: 24,
  OVERSEAS_VN: 25,
  OVERSEAS_KR: 26,
  OVERSEAS_TW: 27,
  OVERSEAS_SG: 28,
  OVERSEAS_TH: 29,
  OVERSEAS_MY: 30,
  OVERSEAS_ID: 31,
  OVERSEAS_PH: 32,
  OVERSEAS_IL: 33,
}

export const countryList = {
  usa: "US",
  hongkong: "HK",
  china: "CN",
  korea: "KR",
  taiwan: "TW",
  singapore: "SG",
  thai: "TH",
  malaysia: "MY",
  indonesia: "ID",
  philippine: "PH",
  vietnam: "VN",
  israel: "IL",
}

export const MARKET_CONDITIONS_REPORT_URL =
  "https://www.aizawa.co.jp/market/shikyo.html"

export const MANUAL_URL =
  "https://www.trkd-asia.com/aizawa/globalnavi_guide.pdf?v=3.30"

export const NODEDIST_REGIST_EXCEPTION_EXCHANGE = [
  101,
  102,
  100,
  400,
  2111,
  2110,
  13101,
  13102,
  14200,
  14106,
  14100,
  14110,
]

export const RateList = [
  { symbol: "JPY", exchange: 1 }, //日本
  { symbol: "USD/JPY", exchange: 100 }, //アメリカ
  { symbol: "USD/JPY", exchange: 101 },
  { symbol: "USD/JPY", exchange: 102 },
  { symbol: "HKD/JPY", exchange: 2010 }, //香港
  { symbol: "HKD/JPY", exchange: 2011 },
  { symbol: "HKD/JPY", exchange: 3010 },
  { symbol: "HKD/JPY", exchange: 3011 },
  { symbol: "CNY/JPY", exchange: 2020 }, //中国
  { symbol: "CNY/JPY", exchange: 2021 },
  { symbol: "CNY/JPY", exchange: 2022 },
  { symbol: "CNY/JPY", exchange: 3020 },
  { symbol: "CNY/JPY", exchange: 3021 },
  { symbol: "CNY/JPY", exchange: 3022 },
  { symbol: "TWD/JPY", exchange: 2030 }, //台湾
  { symbol: "TWD/JPY", exchange: 2031 },
  { symbol: "KRW/JPY", exchange: 2040 }, //韓国
  { symbol: "KRW/JPY", exchange: 2041 },
  { symbol: "KRW/JPY", exchange: 2042 },
  { symbol: "SGD/JPY", exchange: 2050 }, //シンガポール
  { symbol: "SGD/JPY", exchange: 2051 },
  { symbol: "THB/JPY", exchange: 2060 }, //タイ
  { symbol: "THB/JPY", exchange: 2061 },
  { symbol: "MYR/JPY", exchange: 2070 }, //マレーシア
  { symbol: "MYR/JPY", exchange: 2071 },
  { symbol: "IDR/JPY", exchange: 2080 }, //インドネシア
  { symbol: "IDR/JPY", exchange: 2081 },
  { symbol: "PHP/JPY", exchange: 2090 }, //フィリピン
  { symbol: "PHP/JPY", exchange: 2091 },
  { symbol: "VND/JPY", exchange: 2100 }, //ベトナム
  { symbol: "VND/JPY", exchange: 2101 },
  { symbol: "VND/JPY", exchange: 2102 },
]

export type history = {
  length: number
  action: string
  location: object
  createHref: Function
  push: Function
  replace: Function
  go: Function
  goBack: Function
  goForward: Function
  block: Function
  listen: Function
}
